import type { Alpha3Code } from 'i18n-iso-countries'
import { useMemo } from 'react'

import { useAuth } from '../useAuth/useAuth'
import { volunteeringAllowedOrgCountriesAlpha3 } from '../../data/sanctionedCountries'

import { getRegionsFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'
import type { Region } from '@percent/workplace-giving/context/auth/authContext/AuthContext.types'

export type UseRegionsResult = Readonly<{
  regions: Region[] | null
  allCountries: Alpha3Code[]
}>

export const useRegions = (): UseRegionsResult => {
  const { state: authState } = useAuth()
  const regions = getRegionsFromAuthState(authState)

  const allCountries = useMemo(
    () =>
      Array.from(
        new Set(
          !regions
            ? (volunteeringAllowedOrgCountriesAlpha3 as Alpha3Code[])
            : regions.flatMap(region => region.countryCodes)
        )
      ),
    [regions]
  )

  return { regions, allCountries }
}
